import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/* Reveals any element with the `reveal` class as it scrolls into view (adds `in-view`).
   Re-scans on route change and observes late-mounted nodes. Zero layout impact. */
export default function ScrollReveal() {
  const location = useLocation();
  useEffect(() => {
    if (typeof IntersectionObserver === "undefined") return;
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add("in-view"); io.unobserve(e.target); }
        });
      },
      { threshold: 0.12, rootMargin: "0px 0px -8% 0px" }
    );
    const scan = () => document.querySelectorAll(".reveal:not(.in-view)").forEach((el) => io.observe(el));
    scan();
    const mo = new MutationObserver(() => scan());
    mo.observe(document.body, { childList: true, subtree: true });
    // safety: reveal anything already above the fold
    const t = setTimeout(scan, 300);
    return () => { io.disconnect(); mo.disconnect(); clearTimeout(t); };
  }, [location.pathname]);
  return null;
}
